import { currencyCode } from 'Helpers/Geo/data';

const ranges = [];

if (currencyCode === 'AUD') {
  ranges.push(
    { end: 8, label: 'Under A$8.00' },
    { start: 8, end: 13, label: 'A$8.00 - A$12.99' },
    { start: 13, end: 23, label: 'A$13.00 - A$22.99' },
    { start: 23, label: 'Over A$23.00' },
  );
}

if (currencyCode === 'CAD') {
  ranges.push(
    { end: 8, label: 'Under C$8.00' },
    { start: 8, end: 13, label: 'C$8.00 - C$12.99' },
    { start: 13, end: 23, label: 'C$13.00 - C$22.99' },
    { start: 23, label: 'Over C$23.00' },
  );
}

if (currencyCode === 'EUR') {
  ranges.push(
    { end: 5, label: 'Under €5.00' },
    { start: 5, end: 10, label: '€5.00 - €9.99' },
    { start: 10, end: 20, label: '€10.00 - €19.99' },
    { start: 20, label: 'Over €20.00' },
  );
}

if (currencyCode === 'USD') {
  ranges.push(
    { end: 5, label: 'Under $5.00' },
    { start: 5, end: 10, label: '$5.00 - $9.99' },
    { start: 10, end: 20, label: '$10.00 - $19.99' },
    { start: 20, label: 'Over $20.00' },
  );
}

if (currencyCode === 'GBP') {
  ranges.push(
    { end: 5, label: 'Under £5.00' },
    { start: 5, end: 10, label: '£5.00 - £9.99' },
    { start: 10, end: 20, label: '£10.00 - £19.99' },
    { start: 20, label: 'Over £20.00' },
  );
}

if (currencyCode === 'RUB') {
  ranges.push(
    { end: 500, label: 'Under ₽500' },
    { start: 500, end: 800, label: '₽500 - ₽799' },
    { start: 800, end: 1300, label: '₽800 - ₽1299' },
    { start: 1300, label: 'Over ₽1300' },
  );
}

if (currencyCode === 'JPY') {
  ranges.push(
    { end: 500, label: 'Under ¥500' },
    { start: 500, end: 800, label: '¥500 - ¥799' },
    { start: 800, end: 1300, label: '¥800 - ¥1299' },
    { start: 1300, label: 'Over ¥1300' },
  );
}

export default ranges;
